import request from './request';
/**
 * 实名认证相关相关接口
 * @author 小圣贤君
 * @time 2020/2/21
 */
export default {
  /**
   * 获取认证信息
   * @param accountType 账号类型 1：个人 2：企业
   * @param businessId 下单系统用户id
   * @param companyType 公司类型 1：供应商 2：平台
   * @param transactionNo 交易编号 getVerifyAddress接口返回
   */
  getCertInfo(data) {
    let postData = {
      ...data,
      companyType: 1,
      accountType: 1
    }
    return request.post('/fadada/rp/getCertInfo', postData);
  },
  /**
   * 通过uuid获取下载文件url
   * @param uuid
   */
  getDownloadUrl(uuid) {
    return request.get('/fadada/rp/getDownloadUrlByUuid/' + uuid);
  },
  /**
   * 获取授权自动签url
   * @param transactionNo
   * @param customerId
   * @param returnUrl
   */
  getSignAuthUrl(data) {
    return request.get('/fadada/rp/getSignAuthUrl', data);
  },
  /**
   * 获取认证地址
   * @param accountType 账号类型 1：个人 2：企业
   * @param businessId 下单系统用户id
   * @param companyType 公司类型 1：供应商 2：平台
   * @param terminalDevice 终端设备 Wechat IOS Android Web
   * @param merchantCode 商户code
   * @param returnUrl 页面跳转URL
   * @param mobile 用户手机号
   * @param customerIdentNo 用户身份证号
   * @param certType 证件类型
   */
  getVerifyAddress(data) {
    let postData = {
      ...data,
      terminalDevice: "Wechat",
      companyType: 1,
      accountType: 1
    }
    return request.post('/fadada/rp/getVerifyAddress', postData);
  }
}



// WEBPACK FOOTER //
// ./src/api/realNameService.js